import { service } from './service';
/* 供应商可超交料号设置 */

/**
 * @description 供应商可超交料号设置 - 查询列表
 */

export function OverDeliveryPartLoadData(params) {
  return service({
    url: 'OverDeliveryPart/LoadData',
    method: 'get',
    params: params
  });
}
/**
 * @description 供应商可超交料号设置 - 查询料号数据
 */

export function OverDeliveryPartLoadPartData(params) {
  return service({
    url: 'OverDeliveryPart/LoadPartData',
    method: 'get',
    params: params
  });
}
/**
 * @description 供应商可超交料号设置 - 保存数据
 */

export function OverDeliveryPartSaveData(data) {
  return service({
    url: 'OverDeliveryPart/SaveData',
    method: 'post',
    data: data
  });
}